import React, { useMemo } from 'react';
import { ButtonV2 } from 'components/buttonV2';
import { ButtonLabels } from 'constants/buttons';
import { Intent } from 'constants/ui';
export const ToggleAllButton = ({ onClick, shouldDisplayFewer, ...rest }) => {
    const text = useMemo(() => (shouldDisplayFewer ? ButtonLabels.SHOW_FEWER : ButtonLabels.SHOW_ALL), [shouldDisplayFewer]);
    return (React.createElement(ButtonV2, { intent: Intent.NEUTRAL, onClick: onClick, ...rest }, text));
};
